<app-landing></app-landing>
<app-about-me></app-about-me>
<app-skills></app-skills>
<app-portfolio></app-portfolio>
<app-contact></app-contact>